import ReactDOM from 'react-dom/client';
import App from './App';

import registerServiceWorker from 'utils/registerServiceWorker';


registerServiceWorker()

.catch(error => {
  console.error('Service worker registration failed:', error)
})

.then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render( <App /> );
})